// src/shared/components/ui/Button.jsx
// ✅ زر موحد — Modern Dark Ready
import React from 'react';
import styles from './Button.module.css';

/**
 * @param {'primary'|'secondary'|'ghost'|'danger'|'warning'|'info'|'success'|'outlinePrimary'|'outlineDanger'} variant
 * @param {'sm'|'md'|'lg'} size
 * @param {boolean} fullWidth
 * @param {boolean} loading
 * @param {boolean} iconOnly   — زر أيقونة فقط (مربع)
 * @param {React.ReactNode} icon
 * @param {string} type        — نوع الزر (button | submit | reset)
 */
const Button = ({
  children,
  variant   = 'primary',
  size      = 'md',
  fullWidth = false,
  loading   = false,
  iconOnly  = false,
  icon,
  className = '',
  disabled,
  type      = 'button',
  ...rest
}) => {
  const classes = [
    styles.btn,
    styles[variant] || styles.primary,
    styles[size]    || styles.md,
    fullWidth ? styles.fullWidth : '',
    loading   ? styles.loading   : '',
    iconOnly  ? styles.iconOnly  : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      type={type}
      {...rest}
    >
      {icon && !loading && (
        <span className={styles.icon} aria-hidden="true">{icon}</span>
      )}
      {loading ? 'جاري...' : children}
    </button>
  );
};

export default Button;